import AbstractDevice from '../all/AbstractDevice';
import STBCoship9108PlayerUtil from './PlayerUtil';
import STBCoship9108Config from './config';
import AndroidId from '../android/Id';
import AndroidPlayer from '../android/Player';
import AndroidKeys from './Keys';
import AndroidNetworkStatus from '../android/NetworkStatus';
import AndroidSystem from '../android/System';
import logger from 'src/utils/logger/logger';

class STBCoship9108Device extends AbstractDevice {
    constructor() {
        super(
            'android',
            new AndroidId(),
            new AndroidPlayer(),
            new STBCoship9108PlayerUtil(),
            STBCoship9108Config,
            new AndroidKeys(),
            new AndroidNetworkStatus(),
            new AndroidSystem(),
            'stbcoship9108'
        );
    }

    getSubplatform() {
        return 'stbcoship9108';
    }

    update_launcher(region, result) {
        try {
            window.AndroidPlayerInterface.saveLauncher(region, JSON.stringify(result));
        } catch (e) {
            logger.error('[Device.update_launcher]', e);
        }
    }
}

export default STBCoship9108Device;



// WEBPACK FOOTER //
// ./src/devices/stbcoship9108/Device.js